import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UserService} from '../../../../../services/user-services/user.service';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass, NgIf } from '@angular/common';
import { CheckFormErrorDirective } from '../../../../../directives/checkFormError.directive';

@Component({
    selector: 'app-btn-sticky-bot',
    templateUrl: './btn-sticky-bot.component.html',
    styleUrls: ['./btn-sticky-bot.component.scss'],
    standalone: true,
    imports: [CheckFormErrorDirective, NgClass, NgIf, TranslateModule]
})
export class BtnStickyBotComponent implements OnInit {

  @Output() private isSubmit: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() isLoading:boolean = false;
  @Input() btnText = 'COMMON.CONFIRM_INFOS';
  @Input() btnIcon;

  public isMobile: boolean = false;

  constructor(
    private userService: UserService,
  ) { }

  ngOnInit(): void {
    this.isMobile = this.userService.isMobileUser;
  }

  public submit() {
    this.isSubmit.emit(true);
  }

}
